// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NRp1","comment":"styles_comment__26D6S"};